import { useHashimukhTheme } from "./useHashimukhTheme";
export var useStyles = function (maker) {
    var theme = useHashimukhTheme();
    return maker(theme);
};
//# sourceMappingURL=useStyles.js.map